import type { ExchangeRatesDto } from '@paladin-monorepo/common';
import API from '../api';

export const currencyApi = {
  getRates(): Promise<ExchangeRatesDto> {
    return API.get<ExchangeRatesDto>('/currency/rates').then((res) => res.data);
  },
};
